export default "__VITE_ASSET__ee5063ae__"